module.exports = __webpack_public_path__ + "img/Coin BankB01.a1d78caa.png";